"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ControlReportsActionbarComponent = /** @class */ (function () {
    function ControlReportsActionbarComponent() {
    }
    return ControlReportsActionbarComponent;
}());
exports.ControlReportsActionbarComponent = ControlReportsActionbarComponent;
